import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {PrecioGenericViewModel, PrecioViewModel, UserViewModel} from '../../../utils/ViewModels';
import {MdExpansionPanelHeader} from '@angular/material';
import {PricePipe} from '../../../utils';
import {DialogsService, NEG_ACTIONS, PermisosService} from '../../../services';
import * as moment from 'moment';
import {Grupo, Precio} from '../../precios-seccion/general-interfaces';

@Component({
  selector: 'app-precio-monitor',
  templateUrl: './precio-monitor.component.html',
  styleUrls: ['./precio-monitor.component.scss']
})
export class PrecioMonitorComponent implements OnInit {

  @ViewChild(MdExpansionPanelHeader) acordeon: MdExpansionPanelHeader;

  dataSource: Grupo[] = null;

  @Input() type = 'precio';

  @Input() doubleZero = false;
  @Input() isMobile = false;

  priceClickable = true;
  // permiso de creacion de negocios
  createAllowed = false;

  @Input() set precios(value: PrecioMonitor[]) {
    if (value.length) {
      const grupos: Grupo[] = [];
      value.forEach(precio => {
        // si no existe el grupo, lo creamos
        if (grupos.findIndex(x => x.Grupo === precio.Grupo) === -1) {
          grupos.push({Grupo: precio.Grupo, Precios: []});
        }
        // buscamos el grupo e insertamos el precio en el grupo
        const index = grupos.findIndex(x => x.Grupo === precio.Grupo);
        grupos[index].Precios.push({...precio} as Precio)
      })
      this.dataSource = grupos;
    } else {
      this.dataSource = null;
    }
  }

  constructor(
    private pricePipe: PricePipe,
    private dialogsService: DialogsService,
    private permisosService: PermisosService,
  ) {
    this.createAllowed = permisosService.showNegocioAction(NEG_ACTIONS.CREAR);
  }

  ngOnInit() {}

  getVarianza(precio: number): string {
    const pre = this.doubleZero ? this.pricePipe.transform(precio, 'fill,2') : this.pricePipe.transform(precio);
    return precio > 0 ? '+' + pre : pre;
  }

  showPriceDetail(precio: Precio): void {

    if (!this.priceClickable) {return;}

    if (this.type === 'precio') {
      this.dialogsService.showPrecioDetailDialog(
        precio.PrecioRAW.Usuario,
        moment.unix(precio.PrecioRAW.FechaCreacion).format('DD/MM/YY hh.mm') + 'hs',
        precio.PrecioRAW.Validador,
        false,
        moment.unix(precio.PrecioRAW.FechaPublicacion).format('DD/MM/YY hh.mm') + 'hs'
      );
    } else if (this.type === 'pizarra') {
      this.dialogsService.showPrecioDetailDialog(
        precio.PrecioRAW.Usuario,
        moment.unix(precio.PrecioRAW.FechaCreacion).format('DD/MM/YY'),
        precio.PrecioRAW.Validador,
        true,
        moment.unix(precio.PrecioRAW.FechaPublicacion).format('DD/MM/YY hh.mm') + 'hs',
        precio.PrecioRAW.Producto.Producto,
      );
    } else if (this.type === 'cotizacion') {
      this.dialogsService.showPrecioDolarDescripcion(
        precio.PrecioRAW.SubentidadFinanciera.EntidadFinanciera.Nombre,
        precio.PrecioRAW.SubentidadFinanciera.Descripcion,
        precio.PrecioRAW.Usuario,
        precio.PrecioRAW.Validador,
        moment.unix(precio.PrecioRAW.FechaPublicacion).format('DD/MM/YY HH.mm') + ' hs.',
      );
    }
  }

  openNuevoNegocioDialog(precio) {
    this.dialogsService.showNewNegocioResponsiveDialog(false, false, 0, precio);
  }

}

export interface PrecioMonitor {
  Grupo: string;
  Superior: string;
  Inferior: string;
  Precio: number;
  Moneda: string;
  Varianza: number;
  Fecha: string | Date;
  PrecioRAW?: PrecioGenericViewModel;
  SaltoLinea: boolean;
  FechaRaw: number;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/precio-monitor/precio-monitor.component.ts